"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgSetParamsResponse = exports.MsgSetParams = exports.MsgUpdateMarketConfigResponse = exports.MsgUpdateMarketConfig = exports.MsgWithdrawFromPoolResponse = exports.MsgWithdrawFromPool = exports.MsgDepositToPoolResponse = exports.MsgDepositToPool = exports.MsgDeregisterFromPoolResponse = exports.MsgDeregisterFromPool = exports.MsgRegisterToPoolResponse = exports.MsgRegisterToPool = exports.MsgUpdatePoolResponse = exports.MsgUpdatePool = exports.MsgCreatePoolResponse = exports.MsgCreatePool = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pool_1 = require("./pool");
const market_1 = require("./market");
const duration_1 = require("../google/protobuf/duration");
exports.protobufPackage = "Switcheo.carbon.perpspool";
const baseMsgCreatePool = {
    creator: "",
    name: "",
    depositDenom: "",
    shareTokenSymbol: "",
    supplyCap: "",
    depositFee: "",
    withdrawalFee: "",
    baseBorrowFeePerFundingInterval: "",
};
exports.MsgCreatePool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.depositDenom !== "") {
            writer.uint32(26).string(message.depositDenom);
        }
        if (message.shareTokenSymbol !== "") {
            writer.uint32(34).string(message.shareTokenSymbol);
        }
        if (message.supplyCap !== "") {
            writer.uint32(42).string(message.supplyCap);
        }
        if (message.depositFee !== "") {
            writer.uint32(58).string(message.depositFee);
        }
        if (message.withdrawalFee !== "") {
            writer.uint32(66).string(message.withdrawalFee);
        }
        if (message.baseBorrowFeePerFundingInterval !== "") {
            writer.uint32(74).string(message.baseBorrowFeePerFundingInterval);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreatePool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.depositDenom = reader.string();
                    break;
                case 4:
                    message.shareTokenSymbol = reader.string();
                    break;
                case 5:
                    message.supplyCap = reader.string();
                    break;
                case 7:
                    message.depositFee = reader.string();
                    break;
                case 8:
                    message.withdrawalFee = reader.string();
                    break;
                case 9:
                    message.baseBorrowFeePerFundingInterval = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreatePool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.depositDenom =
            object.depositDenom !== undefined && object.depositDenom !== null
                ? String(object.depositDenom)
                : "";
        message.shareTokenSymbol =
            object.shareTokenSymbol !== undefined && object.shareTokenSymbol !== null
                ? String(object.shareTokenSymbol)
                : "";
        message.supplyCap =
            object.supplyCap !== undefined && object.supplyCap !== null
                ? String(object.supplyCap)
                : "";
        message.depositFee =
            object.depositFee !== undefined && object.depositFee !== null
                ? String(object.depositFee)
                : "";
        message.withdrawalFee =
            object.withdrawalFee !== undefined && object.withdrawalFee !== null
                ? String(object.withdrawalFee)
                : "";
        message.baseBorrowFeePerFundingInterval =
            object.baseBorrowFeePerFundingInterval !== undefined &&
                object.baseBorrowFeePerFundingInterval !== null
                ? String(object.baseBorrowFeePerFundingInterval)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.name !== undefined && (obj.name = message.name);
        message.depositDenom !== undefined &&
            (obj.depositDenom = message.depositDenom);
        message.shareTokenSymbol !== undefined &&
            (obj.shareTokenSymbol = message.shareTokenSymbol);
        message.supplyCap !== undefined && (obj.supplyCap = message.supplyCap);
        message.depositFee !== undefined && (obj.depositFee = message.depositFee);
        message.withdrawalFee !== undefined &&
            (obj.withdrawalFee = message.withdrawalFee);
        message.baseBorrowFeePerFundingInterval !== undefined &&
            (obj.baseBorrowFeePerFundingInterval =
                message.baseBorrowFeePerFundingInterval);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseMsgCreatePool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.depositDenom = (_c = object.depositDenom) !== null && _c !== void 0 ? _c : "";
        message.shareTokenSymbol = (_d = object.shareTokenSymbol) !== null && _d !== void 0 ? _d : "";
        message.supplyCap = (_e = object.supplyCap) !== null && _e !== void 0 ? _e : "";
        message.depositFee = (_f = object.depositFee) !== null && _f !== void 0 ? _f : "";
        message.withdrawalFee = (_g = object.withdrawalFee) !== null && _g !== void 0 ? _g : "";
        message.baseBorrowFeePerFundingInterval =
            (_h = object.baseBorrowFeePerFundingInterval) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseMsgCreatePoolResponse = {};
exports.MsgCreatePoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) {
            pool_1.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreatePoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = pool_1.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreatePoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.Pool.fromJSON(object.pool)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined &&
            (obj.pool = message.pool ? pool_1.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreatePoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.Pool.fromPartial(object.pool)
                : undefined;
        return message;
    },
};
const baseMsgUpdatePool = { creator: "", poolId: long_1.default.UZERO };
exports.MsgUpdatePool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(16).uint64(message.poolId);
        }
        if (message.updatePoolParams !== undefined) {
            pool_1.UpdatePoolParams.encode(message.updatePoolParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdatePool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.poolId = reader.uint64();
                    break;
                case 3:
                    message.updatePoolParams = pool_1.UpdatePoolParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdatePool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.updatePoolParams =
            object.updatePoolParams !== undefined && object.updatePoolParams !== null
                ? pool_1.UpdatePoolParams.fromJSON(object.updatePoolParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.updatePoolParams !== undefined &&
            (obj.updatePoolParams = message.updatePoolParams
                ? pool_1.UpdatePoolParams.toJSON(message.updatePoolParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdatePool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.updatePoolParams =
            object.updatePoolParams !== undefined && object.updatePoolParams !== null
                ? pool_1.UpdatePoolParams.fromPartial(object.updatePoolParams)
                : undefined;
        return message;
    },
};
const baseMsgUpdatePoolResponse = {};
exports.MsgUpdatePoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) {
            pool_1.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdatePoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = pool_1.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdatePoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.Pool.fromJSON(object.pool)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined &&
            (obj.pool = message.pool ? pool_1.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdatePoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.Pool.fromPartial(object.pool)
                : undefined;
        return message;
    },
};
const baseMsgRegisterToPool = {
    creator: "",
    poolId: long_1.default.UZERO,
    marketId: "",
};
exports.MsgRegisterToPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(16).uint64(message.poolId);
        }
        if (message.marketId !== "") {
            writer.uint32(26).string(message.marketId);
        }
        if (message.marketConfigParams !== undefined) {
            market_1.UpdateMarketConfigParams.encode(message.marketConfigParams, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterToPool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.poolId = reader.uint64();
                    break;
                case 3:
                    message.marketId = reader.string();
                    break;
                case 4:
                    message.marketConfigParams = market_1.UpdateMarketConfigParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRegisterToPool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.marketConfigParams =
            object.marketConfigParams !== undefined &&
                object.marketConfigParams !== null
                ? market_1.UpdateMarketConfigParams.fromJSON(object.marketConfigParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.marketId !== undefined && (obj.marketId = message.marketId);
        message.marketConfigParams !== undefined &&
            (obj.marketConfigParams = message.marketConfigParams
                ? market_1.UpdateMarketConfigParams.toJSON(message.marketConfigParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRegisterToPool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.marketId = (_b = object.marketId) !== null && _b !== void 0 ? _b : "";
        message.marketConfigParams =
            object.marketConfigParams !== undefined &&
                object.marketConfigParams !== null
                ? market_1.UpdateMarketConfigParams.fromPartial(object.marketConfigParams)
                : undefined;
        return message;
    },
};
const baseMsgRegisterToPoolResponse = {};
exports.MsgRegisterToPoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRegisterToPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRegisterToPoolResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRegisterToPoolResponse);
        return message;
    },
};
const baseMsgDeregisterFromPool = { creator: "", marketId: "" };
exports.MsgDeregisterFromPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeregisterFromPool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeregisterFromPool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.marketId !== undefined && (obj.marketId = message.marketId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgDeregisterFromPool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.marketId = (_b = object.marketId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgDeregisterFromPoolResponse = {};
exports.MsgDeregisterFromPoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeregisterFromPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDeregisterFromPoolResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDeregisterFromPoolResponse);
        return message;
    },
};
const baseMsgDepositToPool = {
    creator: "",
    poolId: long_1.default.UZERO,
    depositAmount: "",
    minShareAmount: "",
};
exports.MsgDepositToPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(16).uint64(message.poolId);
        }
        if (message.depositAmount !== "") {
            writer.uint32(26).string(message.depositAmount);
        }
        if (message.minShareAmount !== "") {
            writer.uint32(34).string(message.minShareAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDepositToPool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.poolId = reader.uint64();
                    break;
                case 3:
                    message.depositAmount = reader.string();
                    break;
                case 4:
                    message.minShareAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDepositToPool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.depositAmount =
            object.depositAmount !== undefined && object.depositAmount !== null
                ? String(object.depositAmount)
                : "";
        message.minShareAmount =
            object.minShareAmount !== undefined && object.minShareAmount !== null
                ? String(object.minShareAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.depositAmount !== undefined &&
            (obj.depositAmount = message.depositAmount);
        message.minShareAmount !== undefined &&
            (obj.minShareAmount = message.minShareAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgDepositToPool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.depositAmount = (_b = object.depositAmount) !== null && _b !== void 0 ? _b : "";
        message.minShareAmount = (_c = object.minShareAmount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgDepositToPoolResponse = {};
exports.MsgDepositToPoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDepositToPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDepositToPoolResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDepositToPoolResponse);
        return message;
    },
};
const baseMsgWithdrawFromPool = {
    creator: "",
    poolId: long_1.default.UZERO,
    shareAmount: "",
    minReceiveAmount: "",
};
exports.MsgWithdrawFromPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(16).uint64(message.poolId);
        }
        if (message.shareAmount !== "") {
            writer.uint32(26).string(message.shareAmount);
        }
        if (message.minReceiveAmount !== "") {
            writer.uint32(34).string(message.minReceiveAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawFromPool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.poolId = reader.uint64();
                    break;
                case 3:
                    message.shareAmount = reader.string();
                    break;
                case 4:
                    message.minReceiveAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgWithdrawFromPool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.shareAmount =
            object.shareAmount !== undefined && object.shareAmount !== null
                ? String(object.shareAmount)
                : "";
        message.minReceiveAmount =
            object.minReceiveAmount !== undefined && object.minReceiveAmount !== null
                ? String(object.minReceiveAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.shareAmount !== undefined &&
            (obj.shareAmount = message.shareAmount);
        message.minReceiveAmount !== undefined &&
            (obj.minReceiveAmount = message.minReceiveAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgWithdrawFromPool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.shareAmount = (_b = object.shareAmount) !== null && _b !== void 0 ? _b : "";
        message.minReceiveAmount = (_c = object.minReceiveAmount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgWithdrawFromPoolResponse = {};
exports.MsgWithdrawFromPoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgWithdrawFromPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgWithdrawFromPoolResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgWithdrawFromPoolResponse);
        return message;
    },
};
const baseMsgUpdateMarketConfig = { creator: "", marketId: "" };
exports.MsgUpdateMarketConfig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        if (message.updateMarketConfigParams !== undefined) {
            market_1.UpdateMarketConfigParams.encode(message.updateMarketConfigParams, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateMarketConfig);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                case 3:
                    message.updateMarketConfigParams = market_1.UpdateMarketConfigParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateMarketConfig);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.updateMarketConfigParams =
            object.updateMarketConfigParams !== undefined &&
                object.updateMarketConfigParams !== null
                ? market_1.UpdateMarketConfigParams.fromJSON(object.updateMarketConfigParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.marketId !== undefined && (obj.marketId = message.marketId);
        message.updateMarketConfigParams !== undefined &&
            (obj.updateMarketConfigParams = message.updateMarketConfigParams
                ? market_1.UpdateMarketConfigParams.toJSON(message.updateMarketConfigParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgUpdateMarketConfig);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.marketId = (_b = object.marketId) !== null && _b !== void 0 ? _b : "";
        message.updateMarketConfigParams =
            object.updateMarketConfigParams !== undefined &&
                object.updateMarketConfigParams !== null
                ? market_1.UpdateMarketConfigParams.fromPartial(object.updateMarketConfigParams)
                : undefined;
        return message;
    },
};
const baseMsgUpdateMarketConfigResponse = {};
exports.MsgUpdateMarketConfigResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketConfig !== undefined) {
            market_1.MarketConfig.encode(message.marketConfig, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateMarketConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketConfig = market_1.MarketConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateMarketConfigResponse);
        message.marketConfig =
            object.marketConfig !== undefined && object.marketConfig !== null
                ? market_1.MarketConfig.fromJSON(object.marketConfig)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketConfig !== undefined &&
            (obj.marketConfig = message.marketConfig
                ? market_1.MarketConfig.toJSON(message.marketConfig)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateMarketConfigResponse);
        message.marketConfig =
            object.marketConfig !== undefined && object.marketConfig !== null
                ? market_1.MarketConfig.fromPartial(object.marketConfig)
                : undefined;
        return message;
    },
};
const baseMsgSetParams = {
    creator: "",
    quoteIndexPriceFluctuationToleranceRatio: "",
};
exports.MsgSetParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.quoteIndexPriceFluctuationToleranceRatio !== "") {
            writer
                .uint32(18)
                .string(message.quoteIndexPriceFluctuationToleranceRatio);
        }
        if (message.quoteExpiryDuration !== undefined) {
            duration_1.Duration.encode(message.quoteExpiryDuration, writer.uint32(26).fork()).ldelim();
        }
        if (message.marketUtilizationSnapshotInterval !== undefined) {
            duration_1.Duration.encode(message.marketUtilizationSnapshotInterval, writer.uint32(34).fork()).ldelim();
        }
        if (message.maxMarketUtilizationSnapshotWindow !== undefined) {
            duration_1.Duration.encode(message.maxMarketUtilizationSnapshotWindow, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.quoteIndexPriceFluctuationToleranceRatio = reader.string();
                    break;
                case 3:
                    message.quoteExpiryDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.marketUtilizationSnapshotInterval = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxMarketUtilizationSnapshotWindow = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetParams);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.quoteIndexPriceFluctuationToleranceRatio =
            object.quoteIndexPriceFluctuationToleranceRatio !== undefined &&
                object.quoteIndexPriceFluctuationToleranceRatio !== null
                ? String(object.quoteIndexPriceFluctuationToleranceRatio)
                : "";
        message.quoteExpiryDuration =
            object.quoteExpiryDuration !== undefined &&
                object.quoteExpiryDuration !== null
                ? duration_1.Duration.fromJSON(object.quoteExpiryDuration)
                : undefined;
        message.marketUtilizationSnapshotInterval =
            object.marketUtilizationSnapshotInterval !== undefined &&
                object.marketUtilizationSnapshotInterval !== null
                ? duration_1.Duration.fromJSON(object.marketUtilizationSnapshotInterval)
                : undefined;
        message.maxMarketUtilizationSnapshotWindow =
            object.maxMarketUtilizationSnapshotWindow !== undefined &&
                object.maxMarketUtilizationSnapshotWindow !== null
                ? duration_1.Duration.fromJSON(object.maxMarketUtilizationSnapshotWindow)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.quoteIndexPriceFluctuationToleranceRatio !== undefined &&
            (obj.quoteIndexPriceFluctuationToleranceRatio =
                message.quoteIndexPriceFluctuationToleranceRatio);
        message.quoteExpiryDuration !== undefined &&
            (obj.quoteExpiryDuration = message.quoteExpiryDuration
                ? duration_1.Duration.toJSON(message.quoteExpiryDuration)
                : undefined);
        message.marketUtilizationSnapshotInterval !== undefined &&
            (obj.marketUtilizationSnapshotInterval =
                message.marketUtilizationSnapshotInterval
                    ? duration_1.Duration.toJSON(message.marketUtilizationSnapshotInterval)
                    : undefined);
        message.maxMarketUtilizationSnapshotWindow !== undefined &&
            (obj.maxMarketUtilizationSnapshotWindow =
                message.maxMarketUtilizationSnapshotWindow
                    ? duration_1.Duration.toJSON(message.maxMarketUtilizationSnapshotWindow)
                    : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetParams);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.quoteIndexPriceFluctuationToleranceRatio =
            (_b = object.quoteIndexPriceFluctuationToleranceRatio) !== null && _b !== void 0 ? _b : "";
        message.quoteExpiryDuration =
            object.quoteExpiryDuration !== undefined &&
                object.quoteExpiryDuration !== null
                ? duration_1.Duration.fromPartial(object.quoteExpiryDuration)
                : undefined;
        message.marketUtilizationSnapshotInterval =
            object.marketUtilizationSnapshotInterval !== undefined &&
                object.marketUtilizationSnapshotInterval !== null
                ? duration_1.Duration.fromPartial(object.marketUtilizationSnapshotInterval)
                : undefined;
        message.maxMarketUtilizationSnapshotWindow =
            object.maxMarketUtilizationSnapshotWindow !== undefined &&
                object.maxMarketUtilizationSnapshotWindow !== null
                ? duration_1.Duration.fromPartial(object.maxMarketUtilizationSnapshotWindow)
                : undefined;
        return message;
    },
};
const baseMsgSetParamsResponse = {};
exports.MsgSetParamsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetParamsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetParamsResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreatePool = this.CreatePool.bind(this);
        this.UpdatePool = this.UpdatePool.bind(this);
        this.RegisterToPool = this.RegisterToPool.bind(this);
        this.DeregisterFromPool = this.DeregisterFromPool.bind(this);
        this.DepositToPool = this.DepositToPool.bind(this);
        this.WithdrawFromPool = this.WithdrawFromPool.bind(this);
        this.UpdateMarketConfig = this.UpdateMarketConfig.bind(this);
        this.SetParams = this.SetParams.bind(this);
    }
    CreatePool(request) {
        const data = exports.MsgCreatePool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "CreatePool", data);
        return promise.then((data) => exports.MsgCreatePoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdatePool(request) {
        const data = exports.MsgUpdatePool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "UpdatePool", data);
        return promise.then((data) => exports.MsgUpdatePoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    RegisterToPool(request) {
        const data = exports.MsgRegisterToPool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "RegisterToPool", data);
        return promise.then((data) => exports.MsgRegisterToPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeregisterFromPool(request) {
        const data = exports.MsgDeregisterFromPool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "DeregisterFromPool", data);
        return promise.then((data) => exports.MsgDeregisterFromPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    DepositToPool(request) {
        const data = exports.MsgDepositToPool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "DepositToPool", data);
        return promise.then((data) => exports.MsgDepositToPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    WithdrawFromPool(request) {
        const data = exports.MsgWithdrawFromPool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "WithdrawFromPool", data);
        return promise.then((data) => exports.MsgWithdrawFromPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateMarketConfig(request) {
        const data = exports.MsgUpdateMarketConfig.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "UpdateMarketConfig", data);
        return promise.then((data) => exports.MsgUpdateMarketConfigResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetParams(request) {
        const data = exports.MsgSetParams.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.perpspool.Msg", "SetParams", data);
        return promise.then((data) => exports.MsgSetParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
